import { render, staticRenderFns } from "./handgrading.vue?vue&type=template&id=0ccff71e&scoped=true&"
import script from "./handgrading.vue?vue&type=script&lang=ts&"
export * from "./handgrading.vue?vue&type=script&lang=ts&"
import style0 from "./handgrading.vue?vue&type=style&index=0&id=0ccff71e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccff71e",
  null
  
)

export default component.exports